// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".social-btn-group[data-v-6d62606e]{margin-top:20px}.social-btn-group .btn[data-v-6d62606e]{margin-bottom:1.5rem}.social-btn-group .btn i[data-v-6d62606e]{float:left;font-size:23px}.social-btn-group .btn i.fa-facebook[data-v-6d62606e]{color:#3f51b5}.social-btn-group .btn i.fa-google[data-v-6d62606e]{color:#f44336}.h3[data-v-6d62606e]{margin-bottom:2rem}.resend-link.disabled[data-v-6d62606e]{opacity:.5;pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
